/**
 * Runtime API endpoints.
 * Defaults to localhost for dev. Set VITE_* env vars for production builds.
 */

export const AUTH_API_URL: string =
  (typeof import.meta !== 'undefined' && (import.meta as any).env?.VITE_AUTH_API_URL) ??
  (typeof import.meta !== 'undefined' && (import.meta as any).env?.VITE_API_URL) ??
  'http://localhost:3001';

export const STORAGE_API_URL: string =
  (typeof import.meta !== 'undefined' && (import.meta as any).env?.VITE_STORAGE_API_URL) ??
  'http://localhost:3003';

export const RELAY_API_URL: string =
  (typeof import.meta !== 'undefined' && (import.meta as any).env?.VITE_RELAY_API_URL) ??
  'http://localhost:3004';

export const PUBLIC_API_URL: string =
  (typeof import.meta !== 'undefined' && (import.meta as any).env?.VITE_PUBLIC_API_URL) ??
  'http://localhost:3002';
